import classNames from 'classnames';
import * as React from 'react';

import { Button, ButtonVariant } from '@/shared/ui/';

import { ConditionView } from '../ConditionView/ConditionView';
import { Icon } from '../Icon/Icon';

import './StepControlPanel.scss';

interface Props extends React.PropsWithChildren {
  prev?: () => void;
  next?: () => void;
  disabledNext?: boolean;
  disabledPrev?: boolean;
  prevContent?: React.FC;
  nextContent?: React.FC;
  prevClasses?: string;
  nextClasses?: string;
  nextBtnText?: string;
  prevBtnText?: string;
  withArrow?: boolean;
  prevWithArrow?: boolean;
}

export const StepControlPanel: React.FC<Props> = ({
  prev,
  next,
  disabledNext,
  disabledPrev,
  prevContent,
  nextContent,
  prevClasses = '',
  nextClasses = '',
  nextBtnText = 'Далі',
  prevBtnText = 'Назад',
  withArrow = true,
  prevWithArrow = true,
  children,
}) => {
  return (
    <div className={classNames('step-control-panel', { 'step-control-panel--single-column': !!children })}>
      <ConditionView if={!children} else={children}>
        <ConditionView if={!!prev}>
          <Button
            variant={ButtonVariant.SECONDARY}
            className={classNames('step-control-panel__button', prevClasses)}
            disabled={disabledPrev}
            onClick={prev}
          >
            {!!prevContent ? (
              React.createElement(prevContent)
            ) : (
              <>
                {prevWithArrow && <Icon name="arrow_back" color="blue" />}
                <span>{prevBtnText}</span>
              </>
            )}
          </Button>
        </ConditionView>

        <ConditionView if={!!next}>
          <Button
            className={classNames('step-control-panel__button', 'step-control-panel__button--right-side', nextClasses)}
            disabled={disabledNext}
            onClick={next}
          >
            {!!nextContent ? (
              React.createElement(nextContent)
            ) : (
              <>
                <span>{nextBtnText}</span>
                <ConditionView if={withArrow}>
                  <Icon name="arrow_forward" color="white" />
                </ConditionView>
              </>
            )}
          </Button>
        </ConditionView>
      </ConditionView>
    </div>
  );
};
